import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { bridge } from '@dc-platform/dc-bridge'
/* Router Modules */
import gucangSales from './modules/gucangSales' // 谷仓销售管理
import overseasSales from './modules/overseasSales' // 谷仓海外销售
import yuntuSales from './modules/yuntuSales' // 云途销售管理
import customer from './modules/customer' // 客户中心
import systemSetting from './modules/systemSetting' // 系统设置
import { usePermissionStore } from '@/stores/permission'

export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/zbu/mobile',
    name: 'DcCosZbuQrcodeMobile',
    meta: { title: '活动扫码页面' },
    component: require('@/views/marketing/marketingManage/templateManage/mobile.vue').default
  },
  /** when your routing map is too long, you can split it into small modules **/
  gucangSales,
  overseasSales,
  yuntuSales,
  customer,
  systemSetting
]
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})
bridge.handleRouterAfter(router)

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  try {
    const whitelist = ['/zbu/mobile'] // 白名单（不需要按钮权限的页面）
    if (!whitelist.includes(to.path)) {
      // 获取按钮权限
      const permissionStore = usePermissionStore()
      const isEmpty = permissionStore.permission.length === 0
      if (isEmpty) await permissionStore.getPermissionBtn()
    }
    next()
  } catch (error) {
    next()
  }
})

export default router
